import React from 'react';
import KeyForPerson from './KeyForPerson';
import StartDate from './StartDate';
import Activation from './Activation';
import { getCustomerId } from '../../helpers/AbloyKeyHelper';

class AccessDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  keyDetails(lease, item, abloyKey) {
    const {validity, where_at, programmed} = abloyKey;

    let startDate = validity && validity.from ? validity.from.slice(0, 16) : null;
    if (where_at !== 'HANDED_OUT' || !programmed) {
      startDate = null
    }

    const customers = lease.primary_customers;
    const customerId = getCustomerId(abloyKey, lease)

    if (!startDate && (!customerId || customers.length == 0)) { return }

    return <div className="card-row">
      <KeyForPerson customers={customers} currentCustomerId={customerId} selectCustomer={this.selectCustomer}/>
      <StartDate startDate={startDate} editDate={this.editDate}/>
    </div>
  }

  render() {
    const lease = this.props.lease;
    const item  = this.props.item;
    const abloyKey = this.props.abloyKey;

    return (
      <div className="card-keys-access">
        {this.keyDetails(lease, item, abloyKey)}
        <Activation
          lease={lease}
          item={item}
          abloyKey={abloyKey}
          updating={this.props.updating}
          abloyUpdatingMessageStatus={this.props.abloyUpdatingMessageStatus}
          abloyKeyOperations={this.props.abloyKeyOperations}
          handedoutToCurrent={this.props.handedoutToCurrent}
          hideRemoveAccess={this.props.hideRemoveAccess}
          getKeyUpdates={this.props.getKeyUpdates}
          removeAccessAK={this.props.removeAccessAK}
          markLostAK={this.props.markLostAK}
          markBrokenAK={this.props.markBrokenAK}
        />
      </div>
    )
  }
}

export default AccessDetails
